<template>
  <div class="wrapper">
    <Tabs :value="labelMsgAccount">
      <TabPane label="个人账户" name="个人账户">
        <personItem ref="personItem" :msgData="msgData" :provinceList='provinceList' />
      </TabPane>
      <!-- <TabPane label="消息盒子" name="消息盒子">
        <div>
          <msgBoxList :list="list" />
        </div>
      </TabPane> -->
    </Tabs>
  </div>
</template>
<script>
  import personItem from "./item.vue";
  import msgBoxList from "./msgBoxList";
  import { mapState, mapActions } from "vuex";
  export default {
    data() {
      return {
        list: [],
        // 有些仿照itest的功能暂时没有，先将关闭（注释的就是）
        msgData: [
          {
            type: 1,
            name: "",
            detail: {
              // subjectArr: [],
              // subjectList: [],
              // gradeArr: [],
              // gradeList: [],
              // curseArr: [],
              // curseList: [],
            },
            oppear: "编辑",
          },
          // {
          //   type: 2,
          //   name: "我加入的班级",
          //   detail: { banji: "11111111111111" },
          //   oppear: "",
          // },
          {
            type: 3,
            name: "密码管理",
            oppear: "修改密码",
          },
          // {
          //   type: 4,
          //   name: "密保设置",
          //   detail: {
          //     username: "aa",
          //     email: "",
          //     cell: "15210622405",
          //     school: "长青小区",
          //   },
          //   oppear: "设置密保问题",
          // },
          // {
          //   type: 5,
          //   name: "我的学习卡",
          //   detail: {
          //     username: "aa",
          //     email: "",
          //     cell: "15210622405",
          //     school: "长青小区",
          //   },
          //   oppear: "添加学习卡",
          //   columns: [
          //     {
          //       title: "学习卡编码",
          //       key: "code",
          //     },
          //     {
          //       title: "激活时间",
          //       key: "actime",
          //     },
          //     {
          //       title: "过期时间",
          //       key: "uptime",
          //     },
          //   ],
          //   data: [{ code: "", actime: "", uptime: "" }],
          // },
        ],
        provinceList: [],
        labelBox: (h) => {
          let _th = this;
          return h("div", [
            h("span", "消息盒子"),
            // h("Badge", {
            //   props: {
            //     count: _th.list.length,
            //   },
            // }),
          ]);
        },
      };
    },
    components: {
      personItem,
      msgBoxList,
    },
    computed: {
      ...mapState({
        userInfo(state) {
          return state.user.userInfo;
        },
        // curseList(state) {
        //   return state.global.curseList;
        // },
        // gradeList(state) {
        //   return state.global.gradeList;
        // },
        // subjectList(state) {
        //   return state.global.subjectList;
        // },
        labelMsgAccount(state) {
          return state.global.labelMsgAccount;
        }
      }),
    },
    mounted() {
      this.$axios.get("/app/student/getInfo").then((res) => {
        if (res.code == 1) {
          this.getProvince()
          if (res.data.city_id != '')
            this.$refs.personItem.getCity(res.data.province_id, res.data.city_id)

          if (res.data.area_id != '')
            this.$refs.personItem.getArea(res.data.city_id, res.data.area_id)
          this.$refs.personItem.selectArea(res.data.area_id)
          this.msgData[0].detail = res.data

          this.msgData[0].detail.campus_id = Number(res.data.campus_id)
          // this.$store.commit("setUserInfo", res.data);
          // this.$Message.success("保存成功");
        } else {
          this.$Message.error(res.msg);
        }
      });
      // this.init();
    },
    methods: {
      // 初始化
      init() {
        this.getNotic()
      },
      // 获取省份
      getProvince() {
        this.$axios.get("/app/region/getProvince").then((res) => {
          if (res.code == 1) {
            this.provinceList = res.data
          }
        });
      },
      // 获取消息盒子数据
      getNotic() {
        this.$axios.get("/app/notice_relation/index").then((res) => {
          if (res.code == 1) {
            this.list = res.data.data
          }
        })
      },
    },
  };
</script>
<style scoped lang="less">
  .wrapper {
    width: 90%;
    margin: 0 auto;
  }
</style>
